import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export type InabilitarCotaUsuarioStatus =
  | "DISTRATO"
  | "VENDIDA_PROPRIO"
  | "VENDIDA_MC"
  | "ERRO_INCLUSAO";

export interface InabilitarCotaUsuarioPayload {
  status: InabilitarCotaUsuarioStatus;
  motivo: string;
  observacoes?: string;
  metadata?: {
    origem?: string;
    protocolo?: string;
    responsavel?: string;
  };
}

export interface InabilitarCotaUsuarioResponse {
  cotaUsuario: {
    id: number;
    status: string;
    active?: number;
    updated_at: string;
  };
  statusSolicitado: string;
  statusFinal: string;
  periodos?: {
    totalAtivosAnalisados: number;
    totalFinalizados: number;
    totalInativados: number;
    totalAlterando: number;
    totalComReserva: number;
  };
  anuncios?: {
    totalDatadosInativacao: number;
    totalComPendencia?: number;
  };
  assinaturas?: {
    totalNaoRenovar: number;
  };
  tokens?: {
    totalInativados: number;
  };
  etiquetas?: {
    totalRemovidas: number;
  };
}

export const inabilitarCotaUsuarioService = async (
  cotaUsuarioId: number,
  values: InabilitarCotaUsuarioPayload
) => {
  const token = validateToken();

  if (!token) {
    throw new Error("Token invalido");
  }

  const url = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}/inabilitar`;

  try {
    const response = await axios.patch(url, values, {
      headers: { Authorization: token.AuthStr },
    });

    return response.data as InabilitarCotaUsuarioResponse;
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao inabilitar cota");
  }
};
